// @ts-expect-error untyped module
import ResultCard from './ResultCard';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useTrackSolutionsDirectoryClickResultItem } from 'marketplace-ui-tracking';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid({
  onResultClick,
  results,
  searchValue = '',
  pageNumber
}) {
  const {
    trackClickResultItem
  } = useTrackSolutionsDirectoryClickResultItem();
  const renderedResults = useMemo(() => {
    return results.toArray().map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, {
        onClick: () => {
          if (onResultClick) {
            onResultClick(result, index);
          }
          trackClickResultItem(result, {
            itemIndex: index,
            totalResults: results.size,
            search: searchValue,
            pageNumber
          });
        },
        result: result
      }, result.name);
    });
  }, [onResultClick, results, trackClickResultItem, searchValue, pageNumber]);
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  });
  return /*#__PURE__*/_jsx(CardGrid, {
    "data-test-id": "search-results-grid",
    gutterSize: 16,
    columns: responsiveProps.columns,
    children: renderedResults
  });
}